export default __webpack_public_path__ + "static/media/filter.d42de084.svg";